import { motion } from 'framer-motion';
import { Users } from 'lucide-react';
import { Button, Card, ProBadge, SectionHeader } from '../../components';
import { useProContext } from '../../pro';

/**
 * Shared Budgets — Pro stub. Backend deferred. Free users see a Pro
 * upsell; Pro users see a "Coming soon" placeholder.
 */
export function SharedBudgetsSection() {
  const pro = useProContext();

  return (
    <motion.div>
      <SectionHeader title="Sharing" />
      <Card elevation="sm" className="mb-section-gap">
        <div className="flex items-start gap-3 mb-3">
          <div className="w-10 h-10 rounded-button bg-accent/10 inline-flex items-center justify-center text-accent shrink-0">
            <Users size={20} strokeWidth={1.5} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <div className="text-[14px] font-semibold text-text-primary">
                Invite a partner
              </div>
              <ProBadge />
            </div>
            <p className="text-[12px] text-text-secondary leading-snug">
              Share a budget with someone you trust: combined transactions,
              shared goals, separate or pooled categories. Coming soon.
            </p>
          </div>
        </div>
        <Button
          variant="primary"
          fullWidth
          onClick={pro.isPro ? undefined : pro.openPaywall}
          disabled={pro.isPro}
        >
          {pro.isPro ? 'Coming soon' : 'Unlock with Pro'}
        </Button>
      </Card>
    </motion.div>
  );
}
